export default "__VITE_ASSET__133cd61a__"